export const appStorage = window.localStorage;

export function setItemLocal(key: string, value: string) {
  try {
    appStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(error);
  }
}

export function getItemLocal<T = any>(key: string): T | undefined {
  try {
    const item = appStorage.getItem(key);
    return item ? JSON.parse(item) : undefined;
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

export function removeItemLocal(key: string) {
  try {
    appStorage.removeItem(key);
  } catch (error) {
    console.error(error);
  }
}

export function clearLocalStorage() {
  try {
    appStorage.clear();
  } catch (error) {
    console.error(error);
  }
}
